import { RequirementStopData } from '../../@types/requirements';
import { Line } from '../../@types/lines';
import LineColor from './LineColor';
import { Marker, Popup } from 'react-leaflet';
import { MakeColorIcon } from '../Layout/styles';

type LineStopMarkersProps = {
    lineStops: StopWithLine[];
    stopPassengers: RequirementStopData[];
    allLines: Line[];
};

export interface StopWithLine {
    ID: number;
    CrmID: number;
    LineID: number;
    LineName: string;
    Name: string;
    Lat: number;
    Lon: number;
    Type: string;
}

const LineStopMarkers = ({ lineStops, stopPassengers, allLines }: LineStopMarkersProps) => {
    return (
        <>
            {lineStops.map((stop: StopWithLine) => {
                const stopPassenger = stopPassengers.find(sp => sp.CrmID === stop.CrmID);
                const nPassenger = stopPassenger ? stopPassenger.NPassengers : 0;
                const color = nPassenger > 0 ? LineColor(allLines, stop.LineID) : 'grey';
                return (
                    <Marker icon={MakeColorIcon(color, color, nPassenger)} key={`marker-${stop.Lat}-${stop.Lon}-${nPassenger}`} position={[stop.Lat, stop.Lon]}>
                        <Popup>
                            {stop.LineName} <br /> <strong>{stop.Name}</strong>
                        </Popup>
                    </Marker>
                );
            })}
        </>
    );
};

export default LineStopMarkers;